import { Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { PriceRealAmountPipe } from './priceRealAmount.pipe';


/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 |  exponentialStrength:10}}
 *   formats to: 1024
*/
@Pipe({ name: 'price' })
export class PricePipe extends PriceRealAmountPipe implements PipeTransform {

    /**
     * Displays the currency depending on the locale:
     * the output can be 1 000,99 € (fr)
     * or $ 1,000.00 (us)
     *
     * This pipe's output is in HTML, digits are inside a <small> tag
     * @param price Number to display
     * @param currencyCode ISO code of the currency
     */
    public transform(price: number | string, currencyCode?: string): SafeHtml {
        const stringValue: SafeHtml = super.transform(+price / 100, currencyCode);
        return stringValue;
    }
}
